import { closeSettingModal } from '../State/settingModal'

export default () => (dispatch) => {

  dispatch(closeSettingModal())
  
}
